export default {
      id: "ic_responsible_gambling_mobile-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_responsible_gambling_mobile-usage",
      toString: function () {
        return this.url;
      }
    }